export default __webpack_public_path__ + "static/media/원데이 클래스 사진 모바일.dddb481a.jpeg";